import { Section, SHELL, INSET_X } from '@/components/base/Frame';
import HeroRibbon from './HeroRibbon';
import TypedTitle from './TypedTitle';

export default function Hero() {
  return (
    <Section id="top" divider headerGap className="overflow-hidden">
      <HeroRibbon />
      <div className={`relative ${SHELL} flex flex-1 items-center py-16 lg:py-8`}>
        <div className={`max-w-[44rem] ${INSET_X}`}>
          <p className="flex items-center gap-3 font-label text-xs uppercase tracking-[0.18em] text-foreground-600">
            <span className="h-px w-6 bg-foreground-400" />
            AI Automation &amp; Implementation
          </p>
          <TypedTitle />
          <p className="mt-8 max-w-[26rem] text-base font-light leading-relaxed text-foreground-700 md:text-lg">
            We redesign operational workflows and implement AI into the systems your team already uses.
          </p>
        </div>
      </div>
    </Section>
  );
}